import PhotoSwipeLightbox from 'photoswipe/lightbox';
import PhotoSwipe from 'photoswipe';
import 'photoswipe/style.css';

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.pe-slider-type-gallery').forEach(setupGalleryLightbox);
});

function setupGalleryLightbox(wrapperEl) {
    const originals = wrapperEl.querySelectorAll(
        '.swiper-slide:not(.swiper-slide-duplicate) .pe-gallery-slide'
    );
    if (!originals.length) {
        return;
    }

    const dataSource = [];
    const indexByImageId = new Map();

    originals.forEach((el, index) => {
        const img = el.querySelector('img');
        dataSource.push({
            src: el.getAttribute('href'),
            width: parseInt(el.dataset.pswpWidth, 10) || undefined,
            height: parseInt(el.dataset.pswpHeight, 10) || undefined,
            alt: img?.alt || '',
        });
        indexByImageId.set(el.dataset.imageId, index);
    });

    const lightbox = new PhotoSwipeLightbox({
        dataSource,
        pswpModule: PhotoSwipe,
    });

    let lastClickedEl = null;
    lightbox.addFilter('thumbEl', (thumbEl) => lastClickedEl || thumbEl);
    lightbox.init();

    wrapperEl.addEventListener('click', (e) => {
        const el = e.target.closest('.pe-gallery-slide');
        if (!el || !wrapperEl.contains(el)) {
            return;
        }
        const index = indexByImageId.get(el.dataset.imageId);
        if (index === undefined) {
            return;
        }
        e.preventDefault();
        lastClickedEl = el.querySelector('img') || el;
        lightbox.loadAndOpen(index);
    });
}
